import ApprovalTable from './ApprovalTable/index'
export default ApprovalTable
